<template>
  <q-dialog
    v-model="show"
    persistent
    transition-show="scale"
    transition-hide="scale"
    style="z-index: 1000001"
  >
    <q-card class="bg-teal text-white" style="width: 360px; max-width: 95vw">
      <q-card-section>
        <div class="text-h6">Сервис обновлен</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Перезагрузите страницу, чтобы изменения вступили в силу.
      </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn flat label="OK" @click="reload" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "ForceReloadDialog",
  computed: {
    show: {
      get() {
        return this.$store.getters.FORCE_RELOAD_REQUIRED;
      },
      set(val) {
        this.$store.commit("SET_FORCE_RELOAD_REQUIRED", Boolean(val));
      }
    }
  },
  methods: {
    reload() {
      window.location.reload();
    }
  }
};
</script>

